import React from 'react';
import { Delete, Edit } from '@mui/icons-material';
import { JobCode, deleteJobCode } from '../../../../core/API/scheduler';
import styles from '../SchedulerSetting.module.scss';

interface JobCodesListProps {
	jobCodes: JobCode[];
	onJobCodeCreated: () => void;
	onEditClick: (jobCode: JobCode) => void;
	canEdit?: boolean;
	canDelete?: boolean;
}

const JobCodesList: React.FC<JobCodesListProps> = ({ jobCodes, onJobCodeCreated, onEditClick, canEdit = true, canDelete = true }) => {
	const handleDeleteClick = async (jobCode: JobCode) => {
		if (!canDelete) return;
		if (jobCodes.length <= 1) return;
		const ok = window.confirm(
			`Are you sure you want to delete job code "${(jobCode as any).label || (jobCode as any).name}"? This action cannot be undone.`
		);
		if (!ok) return;
		try {
			await deleteJobCode(Number((jobCode as any).id));
			onJobCodeCreated();
		} catch (e) {
			console.error('Failed to delete job code:', e);
		}
	};

	return (
		<>
			<div className={styles.tableContainer}>
				<table className={styles.workplaceTable}>
					<thead>
						<tr>
							<th>Job Code Number</th>
							<th>Name</th>
							<th style={{ width: 48, textAlign: 'center' }}>Edit</th>
							<th style={{ width: 48, textAlign: 'center' }}>Delete</th>
						</tr>
					</thead>
					<tbody>
						{[...jobCodes].sort((a, b) => {
							const aNum = (a as any).jobNumber ?? Infinity;
							const bNum = (b as any).jobNumber ?? Infinity;
							return aNum - bNum;
						}).map((jobCode) => (
							<tr key={jobCode.id}>
								<td>
									<span>{(jobCode as any).jobNumber ? String((jobCode as any).jobNumber).padStart(2, '0') : '-'}</span>
								</td>
								<td>
									<span>{jobCode.label}</span>
								</td>
								<td style={{ textAlign: 'center', padding: '8px', width: 48 }}>
									<button
										className={styles.iconButton}
										title={canEdit ? "Edit" : "You do not have permission to edit"}
										onClick={() => onEditClick(jobCode)}
										disabled={!canEdit}
										style={{ opacity: canEdit ? 1 : 0.5, cursor: canEdit ? 'pointer' : 'not-allowed' }}
									>
										<Edit className={styles.editIcon} />
									</button>
								</td>
								<td style={{ textAlign: 'center', padding: '8px', width: 48 }}>
									<button
										onClick={() => handleDeleteClick(jobCode)}
										title={canDelete ? "Delete Job Code" : "You do not have permission to delete"}
										className={styles.iconButton}
										disabled={!canDelete}
										style={{ opacity: canDelete ? 1 : 0.5, cursor: canDelete ? 'pointer' : 'not-allowed' }}
									>
										<Delete className={styles.deleteIcon} />
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default JobCodesList;
